import { LoaderService } from 'src/app/core/_config/loader.service';
import { Subject } from 'rxjs';
import { SchedulingTask } from './../../../../interfaces/SchedulingTask';
import { LineAction } from './../../../../models/simpleListConfig';
import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { SimpleListConfig } from 'src/app/models/simpleListConfig';
import { MatDialog } from '@angular/material/dialog';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SchedulingTaskService } from 'src/app/services/scheduling-task.service';
import { NotificationsService } from 'angular2-notifications';

@Component({
  selector: 'kt-manage-tasks',
  templateUrl: './manage-tasks.component.html'
})
export class ManageTasksComponent implements OnInit {

  @ViewChild('newTask') contentNewtask: ElementRef;
  @ViewChild('editTask') contentEditTask: ElementRef;

  selectedTask: SchedulingTask;
  openNewTask = false;
  taskTypeControl = new FormControl(null);
  resOk: boolean = true;
  tasks: any[] = [];

  constructor(
    private schedulingTaskService: SchedulingTaskService,
    private loader: LoaderService,
    private cdref: ChangeDetectorRef,
    private notificationsService: NotificationsService,
  ) { }

  openTaskModal: Subject<SchedulingTask> = new Subject<SchedulingTask>();

  ngOnInit(): void {
    this.getAllTasks();
  }

  editTask(task) {
    this.openTaskModal.next(task);
  }

  newTask() {
    this.openTaskModal.next();
  }

  getAllTasks() {
    this.loader.show();
    this.resOk = false;
    this.cdref.detectChanges();

    this.schedulingTaskService.getAll().subscribe(res => {
      this.tasks = res.data;
      this.loader.hide();
      this.resOk = true;
      this.cdref.detectChanges();
    })
  }

  runTask(task) {
    this.loader.show();
    this.resOk = false;
    this.cdref.detectChanges();

    this.schedulingTaskService.runTask(task.id).subscribe(res => {
      this.loader.hide();
      this.resOk = true;
      this.cdref.detectChanges();
      this.getAllTasks();
      this.notificationsService.success("", 'Tarefa Executada com Sucesso!');
    })
  }
}
